import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _styled from "@emotion/styled-base";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tfrom,\n\tto {\n\t\t\tborder-color: transparent;\n\t}\n\t50% {\n\t\t\tborder-color: inherit;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useEffect, useState } from 'react';
import { keyframes } from '@emotion/core';
var borderBlink = keyframes(_templateObject());

var SpanWithCursor = _styled("span", {
  target: "e4mpld00",
  label: "SpanWithCursor"
})("animation:", borderBlink, " 1.5s step-end infinite;padding:0.25rem;", function (_ref) {
  var isCursorVisible = _ref.isCursorVisible;
  return isCursorVisible && "\n\tborder-right: 5px solid #aaa;\n  ";
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var DEFAULT_TYPING_SPEED = 125; // lower is faster

var DEFAULT_START_DELAY = 500; // ms to pause at beginning of typing phrase

var DEFAULT_END_DELAY = 2000; // ms to pause at end of typing phrase

var DEFAULT_FINAL_DELAY = 5000; // ms for delay after final phrase

export function WordListTypingAnimation(_ref2) {
  var textList = _ref2.textList,
      _ref2$typingSpeed = _ref2.typingSpeed,
      typingSpeed = _ref2$typingSpeed === void 0 ? DEFAULT_TYPING_SPEED : _ref2$typingSpeed,
      _ref2$startDelay = _ref2.startDelay,
      startDelay = _ref2$startDelay === void 0 ? DEFAULT_START_DELAY : _ref2$startDelay,
      _ref2$endDelay = _ref2.endDelay,
      endDelay = _ref2$endDelay === void 0 ? DEFAULT_END_DELAY : _ref2$endDelay,
      _ref2$finalDelay = _ref2.finalDelay,
      finalDelay = _ref2$finalDelay === void 0 ? DEFAULT_FINAL_DELAY : _ref2$finalDelay;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      currentText = _useState2[0],
      setCurrentText = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isCursorVisible = _useState4[0],
      setIsCursorVisible = _useState4[1];

  var step = useCallback(function (next) {
    var loopNum = next.loopNum,
        isDeleting = next.isDeleting,
        txt = next.txt;
    var i = loopNum % textList.length; // the current part of the phrase to display

    next.txt = textList[i].substring(0, txt.length + (isDeleting ? -1 : 1)); // set text to render in state

    setCurrentText(next.txt); // time between character's render
    // faster x2 when deleting

    var delta = (typingSpeed - Math.random() * 100) / (isDeleting ? 2 : 1); // if we aren't deleting and we've spelled out the whole word,
    // wait 2s before proceeding to delete. We can also add
    // a special case here for a longer delay on the last phrase.

    if (!isDeleting && next.txt === textList[i]) {
      next.isDeleting = true;

      if (i === textList.length - 1) {
        delta = finalDelay;
        setIsCursorVisible(false);
      } else {
        delta = endDelay;
      }
    } else if (isDeleting && next.txt === '') {
      setIsCursorVisible(true); // otherwise check to see if we've finished deleting the whole
      // phrase and if so, wait half a second and start on the next one

      next.loopNum++;
      next.isDeleting = false;
      delta = startDelay;
    }

    setTimeout(function () {
      step(next);
    }, delta);
  }, [endDelay, finalDelay, startDelay, textList, typingSpeed]);
  useEffect(function () {
    // kick it off
    step({
      loopNum: 0,
      isDeleting: false,
      txt: ''
    });
  }, [step]);
  return /*#__PURE__*/React.createElement(SpanWithCursor, {
    isCursorVisible: isCursorVisible
  }, currentText);
}